
export const flashMessage = {
    state: {
        data: {
            show: false,
            type: 'error',
            message: 'Text'
        },
        timeout: 5000
    },
    mutations: {
        flashMessageToggle (state, data) {
            const { show, type, message } = data || {}
            const oldMessage = state.data.message
            state.data = {
                show: show || false,
                type: type || 'error',
                message: message || oldMessage
            }
        }
    },
    actions: {
        flashMessageShow ({ commit, dispatch }, data) {
            if (window.flashMessageTimeout) {
                clearTimeout(window.flashMessageTimeout)
            }
            commit('flashMessageToggle', { ...data, show: true })
            window.flashMessageTimeout = setTimeout(() => {
                commit('flashMessageToggle')
            }, 5000)
        }
    }
}
